import * as React from 'react';

import { RouteSwitcher } from '../../common';
import ManageVendorCreateRoutesConfig from './ManageVendorCreateRoutesConfig';

type Props = Record<string, never>;

const ManageVendorCreateRoutes = (props: Props = {}) => {
  const routesConfigData = ManageVendorCreateRoutesConfig();
  return <RouteSwitcher routesConfigData={routesConfigData} componentProps={props} />;
};

export default ManageVendorCreateRoutes;
